<template>
  <div class="subexponent__company">
    <div
      class="subexponent__company-card"
      v-for="subexponent in subexponents"
      :key="subexponent.id"
    >
      <!---->

      <h2
        class="subexponent__company-card-title"
        @click="toggle(subexponent.id)"
        :class="{
          'subexponent__company-card-title_open': openCardId === subexponent.id
        }"
      >
        {{
          locale === "en"
            ? subexponent.company.name_eng
            : subexponent.company.name_rus
        }}

        <icon name="arrow-down_grey" width="16px" height="16px" />
      </h2>

      <div
        class="subexponent__company-card-content"
        :class="{
          'subexponent__company-card-content_open':
            openCardId === null || openCardId !== subexponent.id
        }"
      >
        <div class="subexponent__company-card-status">
          <div class="subexponent__company-card-status-account">
            <p class="subexponent__company-card-status-account-inf">
              {{ $t("event.subexponent.modal.access") }}
            </p>
          </div>

          <div class="subexponent__company-card-status-account_activated">
            <Select
              :disabled="!hasAccessToWrite"
              :options="subExponentAccess"
              :value="subexponent.is_edit ? 'edit' : 'read'"
              @input="updateSubexponentAccessLevel(subexponent, $event)"
            />
            <p class="subexponent__company-card-status-account-action">
              <template v-if="subexponent.is_edit !== true">
                {{ $t("event.subexponent.modal.colOrgControlsSubexp") }}
              </template>

              <template v-if="subexponent.is_edit === true">
                {{ $t("event.subexponent.modal.colOrgDeletegatedSubexp") }}
              </template>
            </p>
          </div>
        </div>

        <div class="subexponent__company-card-value">
          <div class="subexponent__company-card-value-field">
            <span class="subexponent__company-card-value-field-name">
              {{ $t("event.subexponent.modal.companyProfile") }}
            </span>

            <span class="subexponent__company-card-value-field-value">
              <template v-if="hasCompleteCompany">
                <DotText class="_success">
                  {{ $t("event.subexponent.modal.companyProfileFilled") }}
                </DotText>
              </template>

              <template v-else>
                <DotText class="_warning">
                  {{ $t("event.subexponent.modal.companyProfileNotFilled") }}
                </DotText>
              </template>
            </span>
          </div>

          <div class="subexponent__company-card-value-field">
            <span class="subexponent__company-card-value-field-name">
              {{ $t("event.subexponent.modal.catalogApplication") }}
            </span>

            <span class="subexponent__company-card-value-field-value">
              <template v-if="hasOrder(subexponent)">
                <DotText class="_success">
                  {{ $t("event.subexponent.modal.catalogApplicationSent") }}
                </DotText>
              </template>

              <template v-else>
                <DotText class="_warning">
                  {{ $t("event.subexponent.modal.catalogApplicationNotSent") }}
                </DotText>
              </template>
            </span>
          </div>

          <div class="subexponent__company-card-value-field">
            <span class="subexponent__company-card-value-field-name">
              {{ $t("event.subexponent.modal.participantPasses") }}
            </span>

            <span class="subexponent__company-card_qouta-box">
              <span class="subexponent__company-card_qouta-box-text">
                {{
                  $t("event.passes.outOf", {
                    amount: subexponent.pass_personal,
                    total: subexponent.quota
                  })
                }}
              </span>
              <tooltip
                custom-class="subexponent__company-card-drop__block"
                clickable
                position="bottom"
              >
                <icon class="svg-arrow" name="arrow-down_grey" />
                <template #content>
                  <p class="text-description" style="margin-right: 20px">
                    {{ $t("event.subexponent.modal.availablePasses") }}
                    {{ availableQuotas }}
                  </p>

                  <InputNumber
                    :min="subexponent.pass_personal"
                    :max="availableQuotas + subexponent.quota"
                    v-model="subexponent.quota"
                    :disabled="isButtonDisabled"
                    @input="
                      updateSubexponentPersonalPassesQuota(subexponent, $event)
                    "
                  />
                </template>
              </tooltip>
              <!--              <ValueDropDown content-classes="value-drop__block-content">-->
              <!--                <template #head>-->
              <!--              -->
              <!--                </template>-->
              <!--                <template #body>-->
              <!--                  <p class="value-drop__block-text">-->
              <!--                    {{ $t("event.subexponent.modal.availablePasses") }}-->
              <!--                    {{ availableQuotas }}-->
              <!--                  </p>-->

              <!--                  <InputNumber-->
              <!--                    :min="subexponent.pass_personal"-->
              <!--                    :max="availableQuotas + subexponent.quota"-->
              <!--                    v-model="subexponent.quota"-->
              <!--                    :disabled="isButtonDisabled"-->
              <!--                    @input="-->
              <!--                      updateSubexponentPersonalPassesQuota(subexponent, $event)-->
              <!--                    "-->
              <!--                  />-->
              <!--                </template>-->
              <!--              </ValueDropDown>-->
            </span>
          </div>

          <div class="subexponent__company-card-value-field">
            <span class="subexponent__company-card-value-field-name">
              {{ $t("event.subexponent.modal.carPasses") }}
            </span>

            <span class="subexponent__company-card-value-field-value">
              {{ subexponent.pass_car }}
            </span>
          </div>
        </div>

        <div class="subexponent__company-card-form">
          <PrimaryButton
            type="button"
            @click.prevent="$emit('go-to-subexponent', subexponent)"
          >
            <template v-if="subexponent.is_edit && hasAccessToWrite">
              {{ $t("common.editBtn") }}
            </template>

            <template v-else>
              {{ $t("common.lookBtn") }}
            </template>
          </PrimaryButton>

          <LinkIcon
            v-if="hasAccessToWrite"
            icon="delete"
            :grey="true"
            @click="showDeletePopupSubexponent(subexponent)"
          >
            {{ $t("common.deleteBtn") }}
          </LinkIcon>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  PrimaryButton,
  LinkIcon,
  InputNumber,
  DotText,
  Select,
  Tooltip
} from "@v2/shared/ui/components";
import { i18n } from "@v2/shared/config";

export default {
  components: {
    Tooltip,
    InputNumber,
    LinkIcon,
    DotText,
    PrimaryButton,
    Select
  },

  props: ["subexponents", "availableQuotas", "isButtonDisabled"],

  data() {
    return {
      subexponentIdToBeDeleted: null,
      openCardId: null,
      locale: i18n.locale
    };
  },

  computed: {
    ...mapGetters("event", ["hasAccessToWrite", "hasCompleteCompany"]),
    subExponentAccess() {
      return ["edit", "read"].map(item => {
        return {
          value: item,
          title: this.$t(`event.subexponent.${item}`)
        };
      });
    }
  },

  methods: {
    hasOrder(subexponent) {
      return (
        subexponent.catalog_order_id &&
        subexponent.catalog_order_status !== "draft"
      );
    },

    showDeletePopupSubexponent({ id }) {
      this.$emit("onDelete", id);
    },

    toggle(id) {
      this.openCardId = this.openCardId === id ? null : id;
    },

    updateSubexponentAccessLevel(subexponent, accessLevel) {
      this.$emit("update-access-level", {
        subexponent,
        accessLevel
      });
    },

    updateSubexponentPersonalPassesQuota(subexponent, participantPassQuota) {
      this.$emit("update-personal-passes-quota", {
        subexponent,
        participantPassQuota
      });
    }
  },

  watch: {
    subexponents: {
      deep: true,
      handler(v) {
        this.$emit("subexponents-changed", v);
      }
    }
  }
};
</script>

<style lang="scss">
@import "@v2/app/styles/mixins";
@import "@v2/app/styles/media";

.subexponent__company {
  margin: 16px 0 0 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  max-width: 780px;
  width: 100%;

  &-card {
    border-radius: 2px;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.06);
    background-color: #ffffff;
    border: 1px solid #f1f1f1;

    max-width: 380px;
    width: 100%;

    margin-bottom: 24px;

    @include respond-down(lg) {
      max-width: 350px;
    }

    @media (min-width: 740px) and (max-width: 767px) {
      max-width: 330px;
    }

    @include respond-down(md) {
      max-width: 100%;
    }
    &-drop__block {
      display: flex;
      justify-content: space-between;
      background-color: #f0f5f9 !important;
      border: transparent !important;
      align-items: center;
      left: -100px !important;
      &::before {
        display: none !important;
      }
    }
    &_qouta {
      &-box {
        display: flex;
        color: #6d7179;
        font-size: 14px;
        font-weight: 500;
        width: 113px;
        &-text {
          margin-right: 10px;
          display: inline-block;
          opacity: 0.8;
        }
      }
    }
    &-content {
      padding: 0 0 32px 0;

      @include respond-down(md) {
        &_open {
          display: none;
        }
      }
    }
    & .svg-icon.svg-arrow {
      width: 12px;
      height: 12px;

      &._rotated {
        transform: rotate(180deg);
      }
    }
    &-title {
      font-size: 16px;
      font-weight: 400;

      line-height: 1.5;

      color: #505050;
      padding: 14px 31px 8px 26px;
      margin: 0 0 0 0;

      min-height: 80px;

      display: flex;
      align-items: center;
      box-sizing: border-box;

      svg {
        display: none;
      }

      @include respond-down(md) {
        svg {
          display: block;
        }

        justify-content: space-between;

        font-size: 14px;

        padding: 16px 24px 20px 24px;
        min-height: auto;
        box-sizing: border-box;

        &_open .svg-icon {
          transform: rotate(-180deg);
        }
      }
    }

    &-status {
      background-color: rgba(241, 241, 241, 0.5);
      padding: 17px 0 20px 32px;
      display: flex;
      align-items: flex-start;

      @include respond-down(md) {
        padding: 17px 24px 24px 24px;
        justify-content: space-between;
      }

      &-account {
        &-inf {
          font-size: 13px;
          line-height: 1.54;
          color: #000000;
          margin: 0 0 0 0;

          @include respond-down(md) {
            font-size: 12px;
          }
        }

        &-action {
          font-size: 12px;
          line-height: 1.5;
          color: #a3a8b3;
          margin: 5px 0 0 0;

          max-width: 170px;

          @include respond-down(md) {
            font-size: 11px;
          }
        }

        &_activated {
          margin-left: 23px;
          & .select__toggle {
            width: 100%;
            height: auto;
            border: transparent;
            padding: 0;
            background-color: transparent;
            &.select__toggle_disabled {
              background-color: transparent;
              & .svg-icon {
                color: #cdced0;
              }
            }
          }
          & .select__toggle-text {
            color: #6d7179;
            overflow: visible;
            width: auto;
            font-weight: 500;
            font-size: 14px;
          }
          & .select__toggle .svg-icon {
            color: #6d7179;
            width: 14px;
            height: 14px;
          }
        }
      }

      &-btn {
        max-width: 120px;
        display: flex;
        text-align: left;
        border: none;
        outline: none;
        font-size: 12px;
        font-weight: 500;
        line-height: 1.67;
        color: #a3a8b3;
        background-color: transparent;
        padding: 0 0 0 0;
        margin: 3px 0 0 20px;

        @include respond-down(md) {
          font-size: 10px;
          margin: 0;
          width: 75px;
        }

        .svg-icon {
          width: 16px;
          height: 16px;
          flex-shrink: 0;
          color: #a3a8b3;
          margin: 1px 9px 0 0;
          padding: 0 0 0 0;
        }
      }
    }

    &-value {
      padding: 0 32px 0 32px;
      margin: 13px 0 0 0;

      :last-child {
        border: none;
      }

      @include respond-down(md) {
        padding: 0 24px;
      }

      &-field {
        border-bottom: 1px solid #f1f1f1;
        padding: 13px 0 15px 0;
        display: flex;
        justify-content: space-between;
        align-items: center;

        &-name {
          font-size: 13px;
          line-height: 1.54;

          @include respond-down(md) {
            font-size: 12px;
          }
        }

        &-value {
          display: flex;
          width: 113px;
          color: #6d7179;
          font-size: 13px;

          @include respond-down(md) {
            font-size: 12px;
          }
        }
      }
    }

    &-form {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 32px 0 32px;
      margin: 20px 0 0 0;
    }
  }
}
.value-drop__block-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #f0f5f9;
}
</style>
